import { Observable } from 'rxjs';
import { gql } from "graphql-tag";
import { Component, Input,ChangeDetectorRef } from "@angular/core";
import { CustomColumnComponent, DataService } from "@bb-vendure/admin-ui/core";
import { HttpClientModule } from "@angular/common/http";

@Component({
  selector: "total-link-cell",
  imports: [HttpClientModule],
  template: ` <a>{{ totalLinks }}</a> `,
  standalone: true,
})
export class TotalLinksCell implements CustomColumnComponent {
  @Input() rowItem: { id: string };
  totalLinks: number;

  constructor(private dataService: DataService, private cdr: ChangeDetectorRef) {}

  async ngOnInit() {
    this.dataService
      .query(FETCH_TOTAL_LINKS, { productId: this.rowItem.id })
      .single$.subscribe((data) => {
        const total = (data as TotalLinksType).fanClubLinks.totalItems;
        this.totalLinks = total;
        this.cdr.detectChanges();
      });
  }
}

type TotalLinksType = {
  fanClubLinks: {
    totalItems: number;
  };
};

const FETCH_TOTAL_LINKS = gql`
  query FetchTotalLinks($productId: String!) {
    fanClubLinks(
      options: { filter: { productId: { eq: $productId } }, take: 1 }
    ) {
      totalItems
    }
  }
`;
